import React from 'react'
import styles from './section.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const Section = ({
  classes,
  className,
  children,
  title,
  pending,
  renderHeader,
  id
}) => (
  <div
    id={id}
    className={classNames(classes.container, className, {
      [classes.pending]: pending
    })}>
    {(title || renderHeader) && (
      <div className={classes.head}>
        {title && <h3 className={classes.title}>{title}</h3>}
        {renderHeader && renderHeader()}
      </div>
    )}
    <div className={classes.holder}>{children}</div>
  </div>
)

export default injectSheet(styles)(Section)
